export interface IListQueryOptions {
  includeArchived?: boolean;
  limit?: number;
}

export function buildListQueryString(options?: IListQueryOptions): string {
  const params = new URLSearchParams();
  if (options?.includeArchived) params.set('includeArchived', 'true');
  if (typeof options?.limit === 'number' && options.limit > 0) {
    params.set('limit', String(options.limit));
  }
  const query = params.toString();
  return query ? `?${query}` : '';
}
